export const filterModels = (models, values) => {

    if(typeof values !== 'object') values = {id: values};
    else if( Object.keys( values ).length === 0 ) return [];

    return models.filter((model) => {
        for( const key in values ){
            if( ! values.hasOwnProperty( key ) ) continue;
            if( typeof model[ key ] === 'undefined' ) return false;
            if( model[ key ] != values[ key ] ) return false;
        }
        return true;
    }, []);

};


export const findModel = ( models, values ) => {

    if( typeof values !== 'object' ){
        values = {id: values};
    }

    return filterModels( models, values ).shift();
}


export default {
    filterModels,
    findModel,
}
